var _circle, _g, _rect, _rect2, _rect3, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInternalError = function SvgInternalError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#F7F9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#internalError_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 60a2 2 0 0 1 2-2h114a2 2 0 0 1 2 2v10H41V60Z",
    fill: "#464B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 70h118v70a2 2 0 0 1-2 2H43a2 2 0 0 1-2-2V70Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 93 114)",
    fill: "#C9CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 85 102)",
    fill: "#C9CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 110 102)",
    fill: "#C9CED4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 45 66)",
    fill: "#E37570"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 52 66)",
    fill: "#EFBA0F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 59 66)",
    fill: "#4ACC82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.429 57.714c0 9.784-7.931 17.715-17.715 17.715-9.783 0-17.714-7.931-17.714-17.715C141 47.931 148.931 40 158.714 40c9.784 0 17.715 7.93 17.715 17.714Z",
    fill: "#5981E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.371 61.883h-3.413l-.717-13.68h4.847l-.717 13.68Zm-4.187 4.79c0-.88.239-1.492.717-1.836.478-.363 1.061-.545 1.749-.545.669 0 1.243.182 1.721.545.478.344.717.956.717 1.836 0 .841-.239 1.453-.717 1.835-.478.364-1.052.545-1.721.545-.688 0-1.271-.181-1.749-.545-.478-.382-.717-.994-.717-1.835Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "internalError_svg__a",
    x: 31,
    y: 56,
    width: 138,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_4424_219141"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4424_219141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4424_219141",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInternalError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/internalError.svg";